// extracted by mini-css-extract-plugin
export default {"wrapper":"OOFMjbY78CE1UkzrHbb6","h2":"gcXFLEcdOXun4ZiHlVfq","featuresSection":"pEAmXvhWBmZa1v_pOxzs"};